import "../../_generated_templates.js";
import "../../events.js";
import "../intro/intro.js";
import "../submitter_info/submitter_info.js";
import "../question/list.js";
import "../completion_page/list.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.AssessmentNavigator = class AssessmentNavigator extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.renderIntro = this.renderIntro.bind(this);
    this.renderQuestionList = this.renderQuestionList.bind(this);
    this.renderCompletionPageList = this.renderCompletionPageList.bind(this);
    this.renderSubmitterInfo = this.renderSubmitterInfo.bind(this);
    this.handleSubmitterInfoPositionChanged = this.handleSubmitterInfoPositionChanged.bind(this);
    this.addQuestion = this.addQuestion.bind(this);
    this.addCompletionPage = this.addCompletionPage.bind(this);
    this.removeQuestion = this.removeQuestion.bind(this);
    this.removeCompletionPage = this.removeCompletionPage.bind(this);
    this.selectIntro = this.selectIntro.bind(this);
    this.selectSubmitterInfo = this.selectSubmitterInfo.bind(this);
    this.selectQuestion = this.selectQuestion.bind(this);
    this.selectCompletionPage = this.selectCompletionPage.bind(this);
    this.triggerIntroSelected = this.triggerIntroSelected.bind(this);
    this.triggerIntroUnselected = this.triggerIntroUnselected.bind(this);
    this.triggerSubmitterInfoSelected = this.triggerSubmitterInfoSelected.bind(this);
    this.triggerSubmitterInfoUnselected = this.triggerSubmitterInfoUnselected.bind(this);
    this.triggerQuestionSelected = this.triggerQuestionSelected.bind(this);
    this.triggerCompletionPageSelected = this.triggerCompletionPageSelected.bind(this);
    this.triggerQuestionUnselected = this.triggerQuestionUnselected.bind(this);
    this.triggerCompletionPageUnselected = this.triggerCompletionPageUnselected.bind(this);
    this.unselectAll = this.unselectAll.bind(this);
  }

  initialize() {
    this.introView = new AssessmentBuilder.Views.Intro({ model: this.model.get("intro") });
    this.submitterInfoView = new AssessmentBuilder.Views.SubmitterInfo({ model: this.model.get("submitterInfo") });
    this.questionListView = new AssessmentBuilder.Views.QuestionList({
      collection: this.model.get("questions"),
      sortable: true,
    });
    this.completionPageListView = new AssessmentBuilder.Views.CompletionPageList({
      collection: this.model.get("completionPages"),
    });

    return this.listenTo(this.model.get("submitterInfo"), "change:position", this.handleSubmitterInfoPositionChanged);
  }

  render() {
    this.$el.html(this.template(this.model.attributes));
    this.renderIntro();
    this.renderQuestionList();
    this.renderSubmitterInfo();
    this.renderCompletionPageList();
    return this;
  }

  renderIntro() {
    return this.$(".intro-container").html(this.introView.render().el);
  }

  renderQuestionList() {
    return this.$(".question-list-container").html(this.questionListView.render().el);
  }

  renderCompletionPageList() {
    return this.$(".completion-page-list-container").html(this.completionPageListView.render().el);
  }

  renderSubmitterInfo() {
    let container;
    switch (this.model.get("submitterInfo").get("position")) {
      case "before":
        container = ".submitter-info-before-container";
        break;
      default:
        container = ".submitter-info-after-container";
    }

    return this.$(container).html(this.submitterInfoView.render().el);
  }

  // EVENT HANDLERS

  handleIntroClicked() {
    this.selectIntro();
    return this.triggerIntroSelected();
  }

  handleSubmitterInfoClicked() {
    this.selectSubmitterInfo();
    return this.triggerSubmitterInfoSelected();
  }

  handleSubmitterInfoPositionChanged() {
    return this.renderSubmitterInfo();
  }

  handleQuestionClicked(_, question) {
    this.selectQuestion(question);
    return this.triggerQuestionSelected(question);
  }

  handleAddQuestionClicked() {
    const question = this.addQuestion();
    this.selectQuestion(question);
    return this.triggerQuestionSelected(question);
  }

  handleRemoveQuestionClicked(_, question) {
    this.removeQuestion(question);
    return this.triggerQuestionUnselected();
  }

  handleCompletionPageClicked(_, completionPage) {
    this.selectCompletionPage(completionPage);
    return this.triggerCompletionPageSelected(completionPage);
  }

  handleAddCompletionPageClicked() {
    const page = this.addCompletionPage();
    this.selectCompletionPage(page);
    return this.triggerCompletionPageSelected(page);
  }

  handleRemoveCompletionPageClicked(_, completionPage) {
    this.removeCompletionPage(completionPage);
    return this.triggerCompletionPageUnselected();
  }

  checkForUnselectClick(event) {
    if (
      jQuery(event.target).closest(
        "intro-element, submitter-info-element, question-element, add-question-button, completion-page-element, add-completion-page-button",
      ).length
    ) {
      return;
    }

    if (this.introView.unselect()) {
      this.triggerIntroUnselected();
    }
    if (this.submitterInfoView.unselect()) {
      this.triggerSubmitterInfoUnselected();
    }
    if (this.questionListView.unselectAll()) {
      this.triggerQuestionUnselected();
    }
    if (this.completionPageListView.unselectAll()) {
      return this.triggerCompletionPageUnselected();
    }
  }

  // HELPER FUNCTIONS

  addQuestion() {
    const question = new AssessmentBuilder.Models.Question({ position: this.model.get("questions").length });
    this.model.get("questions").add(question);
    return question;
  }

  addCompletionPage() {
    const completionPage = new AssessmentBuilder.Models.CompletionPage();
    this.model.get("completionPages").add(completionPage);
    return completionPage;
  }

  removeQuestion(question) {
    this.model.get("questions").remove(question);
    return this.unselectAll();
  }

  removeCompletionPage(completionPage) {
    this.model.get("completionPages").remove(completionPage);
    return this.unselectAll();
  }

  selectIntro() {
    this.unselectAll();
    return this.introView.select();
  }

  selectSubmitterInfo() {
    this.unselectAll();
    return this.submitterInfoView.select();
  }

  selectQuestion(question) {
    this.unselectAll();
    return this.questionListView.selectItem(question);
  }

  selectCompletionPage(completionPage) {
    this.unselectAll();
    return this.completionPageListView.selectItem(completionPage);
  }

  triggerIntroSelected() {
    return this.$el.trigger(AssessmentBuilder.Events.AssessmentNavigator.introSelected);
  }

  triggerIntroUnselected() {
    return this.$el.trigger(AssessmentBuilder.Events.AssessmentNavigator.introUnselected);
  }

  triggerSubmitterInfoSelected() {
    return this.$el.trigger(AssessmentBuilder.Events.AssessmentNavigator.submitterInfoSelected);
  }

  triggerSubmitterInfoUnselected() {
    return this.$el.trigger(AssessmentBuilder.Events.AssessmentNavigator.submitterInfoUnselected);
  }

  triggerQuestionSelected(question) {
    return this.$el.trigger(AssessmentBuilder.Events.AssessmentNavigator.questionSelected, question);
  }

  triggerCompletionPageSelected(completionPage) {
    return this.$el.trigger(AssessmentBuilder.Events.AssessmentNavigator.completionPageSelected, completionPage);
  }

  triggerQuestionUnselected() {
    return this.$el.trigger(AssessmentBuilder.Events.AssessmentNavigator.questionUnselected);
  }

  triggerCompletionPageUnselected() {
    return this.$el.trigger(AssessmentBuilder.Events.AssessmentNavigator.completionPageUnselected);
  }

  unselectAll() {
    this.questionListView.unselectAll();
    this.completionPageListView.unselectAll();
    this.completionPageListView.unselectAll();
    this.introView.unselect();
    return this.submitterInfoView.unselect();
  }
};
AssessmentBuilder.Views.AssessmentNavigator.prototype.tagName = "assessment-navigator";
AssessmentBuilder.Views.AssessmentNavigator.prototype.className = "assessment-navigator";
AssessmentBuilder.Views.AssessmentNavigator.prototype.template = _.template(
  AssessmentBuilder.Templates.Assessment.navigator,
);

AssessmentBuilder.Views.AssessmentNavigator.prototype.events = {
  [AssessmentBuilder.Events.Intro.clicked]: "handleIntroClicked",

  [AssessmentBuilder.Events.SubmitterInfo.clicked]: "handleSubmitterInfoClicked",

  "click add-question-button": "handleAddQuestionClicked",
  [AssessmentBuilder.Events.Question.clicked]: "handleQuestionClicked",
  [AssessmentBuilder.Events.Question.removeClicked]: "handleRemoveQuestionClicked",

  "click add-completion-page-button": "handleAddCompletionPageClicked",
  [AssessmentBuilder.Events.CompletionPage.clicked]: "handleCompletionPageClicked",
  [AssessmentBuilder.Events.CompletionPage.removeClicked]: "handleRemoveCompletionPageClicked",

  click: "checkForUnselectClick",
};
